export const getDomainId = () => {
  return localStorage.getItem('domainId')
}

export const getEventId = () => {
  return localStorage.getItem('eventId')
}
